import { render, staticRenderFns } from "./ClientFields.vue?vue&type=template&id=e8b46a26&"
import script from "./ClientFields.vue?vue&type=script&lang=js&"
export * from "./ClientFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports